import React from "react";
import PropTypes from "prop-types";

import { connect } from "react-redux";

import "./List.css";
import ListItem from "./ListItem";

const List = ({ master, masterList, choosenItems }) => {
  return (
    <div className="List">
      {choosenItems.length > 0 && (
        <span className="List_master">{masterList[master][0]}</span>
      )}

      {choosenItems.length < 3 ? (
        choosenItems.map((item, index) => {
          return (
            <span key={index}>
              <ListItem offer={item} />
            </span>
          );
        })
      ) : (
        <>
          <ListItem offer={choosenItems[0]} />
          <ListItem offer={choosenItems[1]} />
          <ListItem offer={`+${choosenItems.length - 2}`} />
        </>
      )}
    </div>
  );
};

//в тегах уберешь начертание болт, и кнопочку чуть ниже ок?)

const mapStateToProps = (state) => {
  return {
    master: state.master,
    masterList: state.masterList,
  };
};

List.propTypes = {
  master: PropTypes.number.isRequired,
  masterList: PropTypes.array.isRequired,
  choosenItems: PropTypes.array.isRequired,
};

export default connect(mapStateToProps)(List);
